export const dateReviver = (key: string, value: unknown): Date | unknown => {
	if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/.exec(value)) {
		return new Date(value);
	}

	return value;
};

export const clone = <T>(obj: T, includeDateParse: boolean = false): T => {
	if (includeDateParse) {
		return JSON.parse(JSON.stringify(obj), dateReviver) as T;
	}
	return JSON.parse(JSON.stringify(obj)) as T;
};
